import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { uniqBy, flatMap } from 'lodash'
Vue.use(Vuex)

const urls = () => ({
  ...Vue.prototype.$wl.urls
})

export default new Vuex.Store({
  state: {
    cursos: [],
    cursosDemo: [],
    config: null,
    detail: null,
    totalCursos: 0,
    totalCursosDemo: 0
  },
  mutations: {
    setCursos (state, payload) {
      state.cursos = payload
    },
    setCursosDemo (state, payload) {
      state.cursosDemo = payload
    },
    setTotalCursosDemo (state, payload) {
      state.totalCursosDemo = payload
    },
    setTotalCursos (state, payload) {
      state.totalCursos = payload
    },
    setDetail (state, payload) {
      state.detail = payload
    }
  },
  actions: {
    postContato ({ commit, state }, data) {
      return axios.post(`${urls().api}/ParcelaPremiada/contato`, data)
    },
    cadastrar ({ state }, data) {
      return axios.post(`${urls().api}/alunos/create`, data).then(response => {
        Object.keys(response.data).length > 0 && sessionStorage.setItem('config', JSON.stringify(response.data))
        return Promise.resolve(response.data)
      })
    },
    async getCursos ({ commit, state }, { regPag = 50, numPag = 0, idSistema = 66, cumulative = false } = {}) {
      const _state = state
      if (!cumulative) commit('setCursos', [])
      const response = await axios.get(`${urls().api}/cursos/listar?idSistema=${idSistema}&numRegPagina=${regPag}&numPagina=${numPag}&categoria=0`)
      const cursos = flatMap(response.data, (categoria) => categoria.cursos)
      commit('setCursos', cumulative ? uniqBy([..._state.cursos, ...cursos], 'id') : cursos)
      commit('setTotalCursos', response?.data[0]?.total ?? _state.totalCursos)
      return cursos
    },
    async getCursosDemo ({ commit, state }, { idSistema = 66 } = {}) {
      const _state = state
      const response = await axios.get(`${urls().api}/cursos/demonstracao?idSistema=${idSistema}`)
      const cursos = flatMap(response.data, (categoria) => categoria.cursos)
      commit('setCursosDemo', cursos)
      commit('setTotalCursosDemo', response?.data[0]?.total ?? _state.totalCursos)
      return cursos
    },
    getDetail ({ commit, state }, id) {
      commit('setDetail', null)
      return axios.get(`${urls().api}/cursos/detalhar/${id}`).then(response => {
        commit('setDetail', response.data)
      })
    }
  }
})
